import { useQuery } from '@tanstack/react-query';
import { jobPositionService } from '../services/jobPosition.service';
import type {
  JobPositionCandidateWithDetails,
  ListJobPositionCandidatesParams,
} from '../types/jobPositionCandidate.types';
import { JobPositionId } from '@/shared/types/branded.types';

interface UseJobPositionCandidatesReturn {
  candidates: JobPositionCandidateWithDetails[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useJobPositionCandidates(
  positionId: string | undefined,
  params: ListJobPositionCandidatesParams = {}
): UseJobPositionCandidatesReturn {
  const query = useQuery({
    queryKey: ['job-position-candidates', positionId, params],
    queryFn: () =>
      jobPositionService.listCandidates({ positionId: JobPositionId(positionId!) }, params),
    enabled: !!positionId,
  });

  return {
    candidates: query.data ?? [],
    hasData: query.data !== undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
